import MilestonesAdapter from './base';

export default class Progression extends MilestonesAdapter {
  modelNamePlural = 'progressions';
}
